import React, { useState, useRef, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import "./FilterModal.css";
import { RxCross1 } from "react-icons/rx";
import { Select } from "antd";
import { filter } from "lodash";

const bedOptions = [
    { value: "", label: "All" },
    { value: "1", label: "1+" },
    { value: "2", label: "2+" },
    { value: "3", label: "3+" },
    { value: "4", label: "4+" },
    { value: "5", label: "5+" },
];
const homeTypes = [
    { value: "", label: "All" },
    { value: "Townhome", label: "Townhome" },
    { value: "Condo", label: "Condo" },
    { value: "Single-Family", label: "Single-Family" },
    { value: "Multifamily", label: "Multi-Family" },
];

const bathOptions = [
    { value: "", label: "All" },
    { value: "1", label: "1+" },
    { value: "2", label: "2+" },
    { value: "3", label: "3+" },
    { value: "4", label: "4+" },
    { value: "5", label: "5+" },
];

const minPrices = [
    // { id: 1, label: "No Min", value: "" },
    { id: 2, label: "$0", value: 0 },
    { id: 3, label: "$50,000", value: 50000 },
    { id: 4, label: "$100,000", value: 100000 },
    { id: 5, label: "$150,000", value: 150000 },
    { id: 6, label: "$200,000", value: 200000 },
    { id: 7, label: "$300,000", value: 300000 },
    { id: 8, label: "$400,000", value: 400000 },
    { id: 9, label: "$500,000", value: 500000 },
    { id: 10, label: "$600,000", value: 600000 },
    { id: 11, label: "$700,000", value: 700000 },
    { id: 12, label: "$800,000", value: 800000 },
    { id: 13, label: "$900,000", value: 900000 },
    { id: 14, label: "$1M", value: 1000000 },
    { id: 15, label: "$2M", value: 2000000 },
    { id: 16, label: "$3M", value: 3000000 },
    { id: 17, label: "$4M", value: 4000000 },
    { id: 18, label: "$5M", value: 5000000 },
    { id: 19, label: "$6M", value: 6000000 },
    { id: 20, label: "$7M", value: 7000000 },
    { id: 21, label: "$8M", value: 8000000 },
    { id: 22, label: "$9M", value: 9000000 },
    { id: 23, label: "$10M", value: 10000000 },
];
const maxPrices = [
    // { id: 1, label: "No Max", value: null },
    { id: 2, label: "$10000", value: 10000 },
    { id: 3, label: "$50,000", value: 50000 },
    { id: 4, label: "$100,000", value: 100000 },
    { id: 5, label: "$150,000", value: 150000 },
    { id: 6, label: "$200,000", value: 200000 },
    { id: 7, label: "$300,000", value: 300000 },
    { id: 8, label: "$400,000", value: 400000 },
    { id: 9, label: "$500,000", value: 500000 },
    { id: 10, label: "$600,000", value: 600000 },
    { id: 11, label: "$700,000", value: 700000 },
    { id: 12, label: "$800,000", value: 800000 },
    { id: 13, label: "$900,000", value: 900000 },
    { id: 14, label: "$1M", value: 1000000 },
    { id: 15, label: "$2M", value: 2000000 },
    { id: 16, label: "$3M", value: 3000000 },
    { id: 17, label: "$4M", value: 4000000 },
    { id: 18, label: "$5M", value: 5000000 },
    { id: 19, label: "$6M", value: 6000000 },
    { id: 20, label: "$7M", value: 7000000 },
    { id: 21, label: "$8M", value: 8000000 },
    { id: 22, label: "$9M", value: 9000000 },
    { id: 23, label: "$10M", value: 10000000 },
];

// const homeTypes = ["Townhouse", "Condo", "Single_Family", "Multifamily"];

const FilterModal = ({
    isOpen = false,
    toggle = () => {},
    setCurrentPage,
    filters = {},
    setFilters = () => {},
    getCornersProperties = () => {},
    clearFilters = () => {},
}) => {
    const defaultFilters = {
        // price: { min: "", max: "" },
        minPrice: "",
        maxPrice: "",
        beds: "",
        baths: "",
        homeType: "",
        sort: "",
    };
    console.log("filters", filters);
    const [minPriceOptions, setMinPriceOptions] = useState(minPrices);
    const [maxPriceOptions, setMaxPriceOptions] = useState(maxPrices);

    // Custom filter function for price options
    const customPriceFilter = (input, option) => {
        if (!input) return true;

        const searchInput = input.toLowerCase().trim();
        const optionLabel = option.label.toLowerCase();

        // 1. Check if the input matches the label directly (existing functionality)
        if (optionLabel.includes(searchInput)) {
            return true;
        }

        // 2. Extract numeric value from the label and compare with input
        // Remove all non-numeric characters except dots for decimal places
        const labelNumericValue = option.label.replace(/[^0-9.]/g, "");
        const inputNumericValue = searchInput.replace(/[^0-9.]/g, "");

        // Handle special cases like "1M", "2M", etc.
        let normalizedLabelValue = labelNumericValue;
        if (option.label.toLowerCase().includes("m")) {
            const baseValue = parseFloat(labelNumericValue);
            if (!isNaN(baseValue)) {
                normalizedLabelValue = (baseValue * 1000000).toString();
            }
        }

        // 3. Check if input matches the numeric value
        if (inputNumericValue && normalizedLabelValue.includes(inputNumericValue)) {
            return true;
        }

        // 4. Check if input as number equals the option value
        const inputAsNumber = parseFloat(inputNumericValue);
        if (!isNaN(inputAsNumber) && option.value === inputAsNumber) {
            return true;
        }

        return false;
    };

    useEffect(() => {
        if (filters.minPrice) {
            const filterValues = maxPrices.filter((option) => option.value > filters.minPrice);
            setFilters((pre) => ({ ...pre, maxPrice: filters?.maxPrice || "" }));
            setMaxPriceOptions(filterValues);
        }
    }, [filters?.minPrice]);

    const modalRef = useRef(null); // Create a ref for the modal content
    const handleFilterChange = (value, key) => {
        if (key.includes(".")) {
            const keys = key.split(".");
            setFilters((prevFilters) => ({
                ...prevFilters,
                [keys[0]]: {
                    ...prevFilters[keys[0]],
                    [keys[1]]: value,
                },
            }));
        } else {
            setFilters((prevFilters) => ({
                ...prevFilters,
                [key]: value,
            }));
        }
    };

    const handleApplyFilters = () => {
        // setCurrentPage(1);
        getCornersProperties();
        toggle();
    };

    const handleResetFilters = () => {
        setFilters(defaultFilters); // Reset filters when explicitly called
        clearFilters(); // Call parent's clearFilters function
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                toggle(); // Close the modal if click is outside
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, toggle]);

    return (
        <div
            onClick={(e) => e.stopPropagation()}
            className="custom-modal  tw-overflow-y-scroll tw-h-[calc(100vh-55px)] tw-mt-[55px]  tw-scrollbar-hide tw-px-4  tw-pt-3 2xl:tw-max--[650px] 2xl:tw-max-w-full tw-bg-white tw-z-[999] tw-shadow-2xl"
            style={{
                maxWidth: "500px",
                margin: 0,
                position: "fixed",
                right: 0,
                top: 0,
                transition: "transform 0.3s ease-in-out",
            }}
        >
            <div className="">
                <div
                    toggle={toggle}
                    className="tw-text-xl tw-mx-4 tw-p-2 tw-border-b-1 tw-flex tw-justify-between tw-border-blacks tw-font-semibold 2xl:tw-text-[27px]"
                >
                    Filters
                    <RxCross1 className="tw-cursor-pointer" onClick={toggle} />
                </div>
                <div className="  tw-px-5 tw-py-3 tw-flex tw-flex-col tw-gap-2 2xl:tw-gap-5">
                    {/* Price Range */}
                    <div className=" tw-bg-[#F5F5F5] tw-px-3 tw-py-2 2xl:tw-p-5 tw-rounded-lg">
                        <label className="tw-text-gray-700 tw-font-semibold 2xl:tw-text-[24px]">Price Range</label>
                        <div className="tw-grid tw-grid-cols-2 tw-gap-2 tw-mt-2">
                            <div className="tw-flex tw-flex-col">
                                <label className="tw-text-sm tw-text-gray-600 2xl:tw-text-[22px]">Minimum</label>
                                <Select
                                    showSearch
                                    style={{
                                        width: 200,
                                    }}
                                    placeholder="No Min"
                                    value={filters?.minPrice}
                                    onChange={(e) => {
                                        handleFilterChange(e, "minPrice");
                                    }}
                                    filterOption={customPriceFilter}
                                    className="tw-w-full tw-h-10 tw-rounded-lg tw-mt-2 tw-outline-none"
                                    options={minPriceOptions}
                                />
                            </div>
                            <div className="tw-flex tw-flex-col">
                                <label className="tw-text-sm tw-text-gray-600 2xl:tw-text-[22px]">Maximum</label>
                                <Select
                                    showSearch
                                    style={{
                                        width: 200,
                                    }}
                                    placeholder="No Max"
                                    value={filters?.maxPrice}
                                    onChange={(e) => {
                                        handleFilterChange(e, "maxPrice");
                                    }}
                                    filterOption={customPriceFilter}
                                    className="tw-w-full tw-h-10 tw-rounded-lg tw-mt-2 tw-outline-none"
                                    options={maxPriceOptions}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Beds */}
                    <div className="tw-bg-[#F5F5F5] tw-px-3 tw-py-2 2xl:tw-p-5 tw-rounded-lg">
                        <label className="tw-text-gray-700 tw-font-semibold 2xl:tw-text-[22px]">Beds</label>
                        <div className="tw-grid tw-grid-cols-6 tw-gap-2 tw-mt-2">
                            {bedOptions.map((option, index) => (
                                <button
                                    key={index}
                                    className={`tw-px-2 tw-py-2 tw-border tw-rounded-md 2xl:tw-text-[18px] ${
                                        filters.beds === option.value ? "tw-bg-[#208177] tw-text-white" : "tw-bg-white tw-text-gray-700"
                                    }`}
                                    onClick={() => handleFilterChange(option.value, "beds")}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Baths */}
                    <div className=" tw-bg-[#F5F5F5] tw-px-3 tw-py-2 2xl:tw-p-5 tw-rounded-lg">
                        <label className="tw-text-gray-700 tw-font-semibold 2xl:tw-text-[22px]">Baths</label>
                        <div className="tw-grid tw-grid-cols-6 tw-gap-2 tw-mt-2">
                            {bathOptions.map((option, index) => (
                                <button
                                    key={index}
                                    className={`tw-px-2 tw-py-2 tw-border tw-rounded-md 2xl:tw-text-[18px] ${
                                        filters.baths === option.value ? "tw-bg-[#208177] tw-text-white" : "tw-bg-white tw-text-gray-700"
                                    }`}
                                    onClick={() => handleFilterChange(option.value, "baths")}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Home Types */}
                    <div className="tw-bg-[#F5F5F5] tw-px-3 tw-py-2 2xl:tw-p-5 tw-rounded-lg">
                        <label className="tw-text-black tw-font-semibold 2xl:tw-text-[22px]">Property Type</label>
                        <div className="tw-flex tw-flex-wrap tw-gap-2 tw-mt-2">
                            {homeTypes.map((option, index) => (
                                <button
                                    key={index}
                                    className={`tw-px-4 tw-py-2 tw-border tw-rounded-md 2xl:tw-text-[18px] ${
                                        filters.homeType === option.value ? "tw-bg-[#208177] tw-text-white" : "tw-bg-white tw-text-gray-700"
                                    }`}
                                    onClick={() => handleFilterChange(option.value, "homeType")}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="tw-flex tw-gap-2 ">
                        <button
                            onClick={handleResetFilters}
                            className="tw-border tw-rounded-lg tw-border-gray-500  tw-bg-white tw-text-gray-700 tw-px-4 tw-py-2 2xl:tw-text-[22px] tw-w-auto hover:tw-border-black"
                        >
                            Reset All Filters
                        </button>

                        <Button
                            onClick={handleApplyFilters} // Apply filters and close modal
                            className="tw-border-[#208177]  tw-bg-[#208177] tw-text-white tw-px-4 tw-py-2 2xl:tw-text-[22px]"
                        >
                            Apply
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterModal;
